export default {
  data() {
    return {
      dialog: false,
      languages: [
        {
          text: 'Русский',
          value: 'ru',
        },
        {
          text: 'English',
          value: 'en',
        },
        {
          text: 'Украинский',
          value: 'uk',
        },
        {
          text: 'Казахский',
          value: 'kk',
        },
        {
          text: 'Испанский',
          value: 'es',
        },
      ],
      locale: this.$route.query.locale || 'ru',
      sort: '',
      name: '',
      description: '',
      image: '',
      imageFile: null,
    }
  },

  methods: {
    getLocalValue(val) {
      if (val === '') {
        return ''
      }
      const obj = JSON.parse(val)
      return obj[this.locale]
    },
    getMultiTextValue(val, local) {
      if (val === '') {
        return ''
      }
      const obj = JSON.parse(val)
      return obj[local]
    },
    getAllLocalValue(val) {
      if (val === '') {
        return ''
      }
      let res = ''
      for (const language of this.languages) {
        const obj = JSON.parse(val)
        res += obj[language.value] + '<br/>'
      }
      return res
    },
    onImageChanged(event) {
      if (event.target.validity.valid && event.target.files.length > 0) {
        this.imageFile = event.target.files[0]
      }
    },
    onSortChanged(val) {
      this.sort = val
    },
    onNameChanged(val) {
      this.name = val
    },
    onDescriptionChanged(val) {
      this.description = val
    },
    async onLanguageChanged(val) {
      this.locale = val
      await this.$router.push({
        query: {
          locale: val,
        },
      })
    },
    onUpload(val) {
      this.files = val
    },
  },
  watch: {
    async $route(to, from) {
      if (to.query.locale) {
        this.locale = to.query.locale
        await this.$apollo.queries.clubs.refetch()
      }
    },
  },
}
